import { Link as RouterLink } from 'react-router-dom';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  Button,
  Flex,
} from '@chakra-ui/react';
import { LockIcon, ArrowForwardIcon, ViewIcon } from '@chakra-ui/icons';

import { useQuoteLock } from '../hooks';

const QuoteLockedBanner = () => {
  const { isLocked, isViewOnly, policyUrl, brokerName } = useQuoteLock();

  if (!isLocked) return null;

  if (isViewOnly) {
    return (
      <Box mb={4}>
        <Alert status="info" variant="subtle" borderRadius="md">
          <AlertIcon as={ViewIcon} boxSize={4} />
          <Box>
            <AlertTitle>View Only</AlertTitle>
            <AlertDescription>
              Created by {brokerName}. Only the broker who created this quote
              can edit it.
            </AlertDescription>
          </Box>
        </Alert>
      </Box>
    );
  }

  return (
    <Box mb={4}>
      <Alert status="info" variant="subtle" borderRadius="md">
        <AlertIcon as={LockIcon} boxSize={4} />
        <Flex
          flex={1}
          align={{ base: 'flex-start', md: 'center' }}
          justify="space-between"
          direction={{ base: 'column', md: 'row' }}
          gap={3}
        >
          <Box>
            <AlertTitle>Form Locked</AlertTitle>
            <AlertDescription>
              This quote has been submitted to application and is no longer
              editable. Continue on the policy form to make changes.
            </AlertDescription>
          </Box>
          {policyUrl && (
            <Button
              as={RouterLink}
              to={policyUrl}
              size="sm"
              colorScheme="blue"
              rightIcon={<ArrowForwardIcon />}
              flexShrink={0}
            >
              Go to Policy
            </Button>
          )}
        </Flex>
      </Alert>
    </Box>
  );
};

export default QuoteLockedBanner;
